import {ComponentProps} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

import {useOfferListingAbroadView} from "../../offer/list/hooks/use_offer_listing_abroad_view_check";
import {useOfferListingHolidayView} from "../../offer/list/hooks/use_offer_listing_holiday_view_check";
import {trackAmplitudeListingFiltersApplied} from "../../offer/tracking/amplitude/track_amplitude_listing_filters_applied";
import {useRecentFiltersDisplay} from "../hooks/use_recent_filters_display";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {recentFiltersLinkConfig} from "../utils/build_recent_filters_search_values";
import {buildRecentFilterMergedFormValues, getRecentFilterFilterText, getRecentFilterSearchUrlWithFilters} from "../utils/recent_filters_display_utils";

interface IProps extends ComponentProps<"div"> {
    recentFiltersLocation?: "listing_page" | "investment_page";
}

/**
 * Component to display the single most recent filter from localStorage.
 * Only shows if user doesn't have active filters.
 */
export const RecentFiltersSidebar = (props: IProps) => {
    const {className, style, recentFiltersLocation = "listing_page"} = props;

    const {recentFilters, latestQuery, shouldShow, currentFormValues} = useRecentFiltersDisplay();

    const isAbroad = useOfferListingAbroadView();
    const isHoliday = useOfferListingHolidayView();

    if (isAbroad || isHoliday) {
        return null;
    }

    if (!shouldShow || recentFilters.length === 0) {
        return null;
    }

    const [recentFilter] = recentFilters;

    return (
        <div className={cx(recentFiltersListWrapperStyle, className)} style={style}>
            <RecentFiltersSidebarItem
                title="Twoje ostatnie filtry"
                filterText={getRecentFilterFilterText(recentFilter)}
                url={getRecentFilterSearchUrlWithFilters({...recentFiltersLinkConfig, recentFilter, currentFormValues, latestQuery})}
                onClick={() =>
                    trackAmplitudeListingFiltersApplied({
                        formValues: buildRecentFilterMergedFormValues({recentFilter, currentFormValues}) as ISearchFiltersFormValues,
                        latestQuery,
                        eventParams: {filter_trigger: "manual", filter_method: "recent_filter_click", location: recentFiltersLocation}
                    })
                }
            />
        </div>
    );
};

interface RecentFiltersSidebarItemProps {
    title: string;
    filterText: string;
    url: string;
    className?: string;
    onClick?: () => void;
}

const RecentFiltersSidebarItem = ({title, filterText, url, className, onClick}: RecentFiltersSidebarItemProps) => (
    <div className={cx(recentFiltersItemStyle, className)}>
        <div className={recentFiltersTextWrapper}>
            <Text variant="body_copy_1">{title}</Text>
            <Text variant="info_txt_1">{filterText}</Text>
        </div>

        <Button href={url} variant="outlined_secondary" size="x-small" className={recentFiltersButton} onClick={onClick}>
            użyj
        </Button>
    </div>
);

const recentFiltersListWrapperStyle = css({
    p: 2,
    display: "flex",
    flexDirection: "column",
    gap: 2,

    md: {
        p: 0
    }
});

const recentFiltersItemStyle = css({
    p: 2,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    justifyContent: "space-between",
    border: "1px solid var(--colors-gray-500)",
    borderRadius: 1,

    md: {
        flexDirection: "row",
        alignItems: "center",
        my: 0
    }
});

const recentFiltersTextWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});

const recentFiltersButton = css({
    width: "100%",

    md: {
        width: "auto"
    }
});
import {ComponentProps} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

import {useOfferListingAbroadView} from "../../offer/list/hooks/use_offer_listing_abroad_view_check";
import {useOfferListingHolidayView} from "../../offer/list/hooks/use_offer_listing_holiday_view_check";
import {trackAmplitudeListingFiltersApplied} from "../../offer/tracking/amplitude/track_amplitude_listing_filters_applied";
import {useRecentFiltersDisplay} from "../hooks/use_recent_filters_display";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {recentFiltersLinkConfig} from "../utils/build_recent_filters_search_values";
import {buildRecentFilterMergedFormValues, getRecentFilterFilterText, getRecentFilterSearchUrlWithFilters} from "../utils/recent_filters_display_utils";

interface IProps extends ComponentProps<"div"> {
    recentFiltersLocation?: "listing_page" | "investment_page";
}

/**
 * Component to display the single most recent filter from localStorage.
 * Only shows if user doesn't have active filters.
 */
export const RecentFiltersSidebar = (props: IProps) => {
    const {className, style, recentFiltersLocation = "listing_page"} = props;

    const {recentFilters, latestQuery, shouldShow, currentFormValues} = useRecentFiltersDisplay();

    const isAbroad = useOfferListingAbroadView();
    const isHoliday = useOfferListingHolidayView();

    if (isAbroad || isHoliday) {
        return null;
    }

    if (!shouldShow || recentFilters.length === 0) {
        return null;
    }

    const [recentFilter] = recentFilters;

    return (
        <div className={cx(recentFiltersListWrapperStyle, className)} style={style}>
            <RecentFiltersSidebarItem
                title="Twoje ostatnie filtry"
                filterText={getRecentFilterFilterText(recentFilter)}
                url={getRecentFilterSearchUrlWithFilters({...recentFiltersLinkConfig, recentFilter, currentFormValues, latestQuery})}
                onClick={() =>
                    trackAmplitudeListingFiltersApplied({
                        formValues: buildRecentFilterMergedFormValues({recentFilter, currentFormValues}) as ISearchFiltersFormValues,
                        latestQuery,
                        eventParams: {filter_trigger: "manual", filter_method: "recent_filter_click", location: recentFiltersLocation}
                    })
                }
            />
        </div>
    );
};

interface RecentFiltersSidebarItemProps {
    title: string;
    filterText: string;
    url: string;
    className?: string;
    onClick?: () => void;
}

const RecentFiltersSidebarItem = ({title, filterText, url, className, onClick}: RecentFiltersSidebarItemProps) => (
    <div className={cx(recentFiltersItemStyle, className)}>
        <div className={recentFiltersTextWrapper}>
            <Text variant="body_copy_1">{title}</Text>
            <Text variant="info_txt_1">{filterText}</Text>
        </div>

        <Button href={url} variant="outlined_secondary" size="x-small" className={recentFiltersButton} onClick={onClick}>
            użyj
        </Button>
    </div>
);

const recentFiltersListWrapperStyle = css({
    p: 2,
    display: "flex",
    flexDirection: "column",
    gap: 2,

    md: {
        p: 0
    }
});

const recentFiltersItemStyle = css({
    p: 2,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    justifyContent: "space-between",
    border: "1px solid var(--colors-gray-500)",
    borderRadius: 1,

    md: {
        flexDirection: "row",
        alignItems: "center",
        my: 0
    }
});

const recentFiltersTextWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});

const recentFiltersButton = css({
    width: "100%",

    md: {
        width: "auto"
    }
});
